import { IRnecSecurity } from '../Interface/IRnecSecurity';
import { ICapruteFingerAgent } from '../Interface/ICapruteFingerAgent';
import { IGetFormatRequest } from '../Interface/IGetFormatRequest';
import axios from 'axios';
import { IValidateFingerAgent } from '../Interface/IValidateFingerAgent';
import { IResponseAgent } from '../Interface/Responses/IResponseAgent';
import { IDataGetFormat } from '../Interface/Responses/IDataGetFormat';
import { IDataValidateFingerprint } from '../Interface/Responses/IDataValidateFingerprint';
import { FingerModel } from '../../authentication-rnec/finger.model';
import { EventsService } from '../../shared/bdb-event.service';
import { CaptureErrorEnum } from '../../enums/capture-error-enum';
import { SessionStorageKeysEnum } from '../../models/session-storage-keys-enum';
import { IDataGetVersion } from '../Interface/Responses/IDataGetVersion';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';

const emailOlimpia = 'olimpia@bancodebogota.com.co'
const errorServicioOlimpia = 'log error servicio olimpia'

const logger = new CustomLogger('RnecAgentModel', 'blue')

export class RnecAgentModel implements IRnecSecurity {
    private readonly urlOlimpiaLocal = 'https://localhost:5000';
    private readonly pathTermsAndConditions = '/SolicitudFormato';
    private readonly pathCaptureFingerPrint = '/SolicitudOlimpia';
    private readonly pathValidateFingerPrint = '/Ingreso';
    private readonly pathGetImei = '/echomac';
    private readonly pathGetVersion = '/getVersion';

    async initializeCaptor(): Promise<void> {
        logger.log('Inicializando captor --->');
        window.open(`olimpiait://reconoser?security='https'`); //activar captor
    }

    async getCaptorVersion(): Promise<IDataGetVersion> {
        try {
            const response = await axios.get(`${this.urlOlimpiaLocal}${this.pathGetVersion}`);
            logger.log('The response from get version --->', response);
            return response.data as IDataGetVersion;
        } catch {
            return {
                Version: '',
                CodigoVersion: -1
            };
        }
    }

    async startCapturingFingerprint(finger: FingerModel, numeroDocumento: number, hand: string): Promise<IResponseAgent> {
        const requestCaptureFingerprint: ICapruteFingerAgent = {
            numeroDocumento,
            NumeroDedo: finger.id,
            TipoDedo: hand,
            login: emailOlimpia
        }

        const response: IResponseAgent = await axios.post(`${this.urlOlimpiaLocal}${this.pathCaptureFingerPrint}`, requestCaptureFingerprint);

        response.data = {
            ...response.data,
            eventName: 'rnecCapture',
            hand,
            finger: finger.id,
        }

        logger.log('The response from capture fingerprint --->', response.data);
        return response;
    }

    async startValidateFingerprint(numeroDocumento: number): Promise<IDataValidateFingerprint> {
        const requestValidateCapture: IValidateFingerAgent = {
            login: emailOlimpia,
            idOficina: 'Oficina Olimpia',
            idProducto: 47,
            numeroDocumento,
            convenio: 'F4C6C791-3AEB-425F-9B7B-A1A8C6C360B0'
        }

        const response: IResponseAgent = await axios.post(`${this.urlOlimpiaLocal}${this.pathValidateFingerPrint}`, requestValidateCapture);
        logger.log('Response from agent:', response);

        response.data.eventName = 'rnec';

        logger.log('The response from validate fingerprint --->', response.data);
        return response.data;
    }

    async startGetTermsAndConditions(numeroDocumento: any): Promise<IDataGetFormat> {
        const requestGetFormatRequest: IGetFormatRequest = {
            codigoConvenio: 'F4C6C791-3AEB-425F-9B7B-A1A8C6C360B0',
            numeroDocumento
        }

        const response = await axios.post(`${this.urlOlimpiaLocal}${this.pathTermsAndConditions}`, requestGetFormatRequest);
        return response.data;
    }

    async reportEvent(result: any, eventService: EventsService) {
        const data = result.data ?? result
        const status = result.status
        try {
            if (!data.eventName) {
                return await eventService.reportEvent('olimpia', errorServicioOlimpia, 'error', null, null, data)
            }

            switch (data.eventName) {
                case 'rnecCapture':
                    return await this.caseRnecCapture(data, status, eventService)
                case 'rnec':
                    return await this.caseRnec(data, eventService);
                default:
                    return await eventService.reportEvent('olimpia', errorServicioOlimpia, 'error', null, null, data)
            }
        } catch (error) {
            return eventService.reportEvent('olimpiaError', errorServicioOlimpia, 'error', null, null, error)
        }
    }

    caseRnecCapture(data: any, status: any, eventService: EventsService) {
        if (status === 200 && !data.Error) {
            return eventService.reportEvent(data.eventName, ' ', 'ok', data.hand, data.finger, data)
        } else if (data.Error && data.descripcionError && data.descripcionError.trim !== null) {
            const error = `${data.Error} | ${data.descripcionError}`
            const resulOperation = CaptureErrorEnum[data.Error] ? CaptureErrorEnum[data.Error].resultOperation : 'error';
            return eventService.reportEvent(data.eventName, error, resulOperation, data.hand, data.finger, data)
        }
    }

    caseRnec(data: any, eventService: EventsService) {
        if (data.resultado) {
            switch (data.resultado) {
                case 'HIT':
                    localStorage.setItem(SessionStorageKeysEnum.CANDIDATE, JSON.stringify(data.candidato));
                    return eventService.reportEvent(data.eventName, data.resultado, 'ok', data.hand, data.finger, data)
                case 'NOHIT':
                    return eventService.reportEvent(data.eventName, data.resultado, 'Precondition Failed', data.hand, data.finger, data)
                default:
                    const error = `${data.codigoError} | ${data.descripcionError}`
                    const resulOperation = CaptureErrorEnum[data.Error]?.resultOperation ?? 'Error';
                    return eventService.reportEvent(data.eventName, error, resulOperation, data.hand, data.finger, data)
            }
        }

        if (data.codigoError && data.descripcionError && data.descripcionError.trim !== null) {
            const error = `${data.codigoError} | ${data.descripcionError}`
            const resulOperation = CaptureErrorEnum[data.Error] ? CaptureErrorEnum[data.Error].resultOperation : 'Error';
            return eventService.reportEvent(data.eventName, error, resulOperation, data.hand, data.finger, data)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication-rnec-v2/model/RnecAgent.model.ts